import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { HelpComponent } from './help/help.component';
import { UserAuthGuard } from './services/user-auth.guard';
import { UserActivityViewComponent } from './activity-log/user-activity-view/user-activity-view.component';

export const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: 'pages/login',
    pathMatch: 'full',
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [UserAuthGuard],
    children: [
      {
        path: '',
        loadChildren: './overview/overview.module#OverviewModule'
      }, {
        path: '',
        loadChildren: './userpage/user.module#UserModule'
      },
      {
        path: '',
        loadChildren: './usermaster/usermaster.module#UsermasterModule'
      },
      {
        path: '',
        loadChildren: './clientmaster/clientmaster.module#ClientmasterModule'
      },
      {
        path: '',
        loadChildren: './devicemaster/devicemaster.module#DevicemasterModule'
      },
      {
        path: '',
        loadChildren: './devicedetails/devicedetails.module#DevicedetailsModule'
      },
       {
        path: '',
        loadChildren: './device-management/device-management.module#DeviceManagementModule'
      },
      {
        path: '',
        loadChildren: './template/dytemplate/dytemplate.module#DytemplateModule'
      },
      {
        path: '',
        loadChildren: './template/power-transformer-template/power-transformer-template.module#PowerTransformerTemplateModule'
      },
      {
        path: '',
        loadChildren: './template/panel-template/panel-template.module#PanelTemplateModule'
      },
      {
        path: '',
        loadChildren: './assetmaster/assetmaster.module#AssetmasterModule'
      }, {
        path: '',
        loadChildren: './sitemanager/sitemanager.module#SitemanagerModule'
      }, {
        path: '',
        loadChildren: './contactmaster/contactmaster.module#ContactmasterModule'
      }, {
        path: '',
        loadChildren: './notificationmaster/notificationmaster.module#NotificationmasterModule'
      }, {
        path: '',
        loadChildren: './triggers/triggers.module#TriggersModule'
      }, {
        path: '',
        loadChildren: './timeline/timeline.module#TimelineModule'
      }, {
        path: '',
        loadChildren: './pmtask/pmtask.module#PmtaskModule'
      }, {
        path: '',
        loadChildren: './pmtasklog/pmtasklog.module#PmtasklogModule'
      }, {
        path: '',
        loadChildren: './greport/greport.module#GreportModule'
      }, {
        path: '',
        loadChildren: './viewreport/viewreport.module#ViewreportModule'
      },
      {
        path: '',
        loadChildren: './iot-devices/iot-devices.module#IotDevicesModule'
      },
      {
        path: '',
        loadChildren: './site-audit/site-audit.module#SiteAuditModule'
      },
      {
        path: '',
        loadChildren: './site-master/site-master.module#SiteMasterModule'
      },
      {
        path: '',
        loadChildren: './site-mapping/site-mapping.module#SiteMappingModule'
      },
      {
        path: '',
        loadChildren: './asset-master/asset-master.module#AssetMasterModule'
      },
      {
        path: '',
        loadChildren: './cms-dashboard/cms-dashboard.module#CmsDashboardModule'
      },
      {
        path: '',
        loadChildren: './reports/reports.module#ReportsModule'
      },
      {
        path: '',
        loadChildren: './customer-complaints/customer-complaints.module#CustomerComplaintsModule'
      },
      {
        path: '',
        loadChildren: './asset-register/asset-register.module#AssetRegisterModule'
      },
      {
        path: '',
        loadChildren: './alerts/alerts.module#AlertsModule'
      },
      {
        path: '',
        loadChildren: './repair-main/repair-main.module#RepairMainModule'
      },
      {
        path: '',
        loadChildren: './alertreciver/alertreciver.module#AlertreciverModule'
      },
      {
        path: '',
        loadChildren: './amcmaster/amcmaster.module#AmcmasterModule'
      },
      {
        path: '',
        loadChildren: './subscription/subscription.module#SubscriptionModule'
      },
      {
        path: '',
        loadChildren: './master/categorymaster/categorymaster.module#CategorymasterModule'
      },
      {
        path: '',
        loadChildren: './client-order-enquiry/client-order-enquiry.module#ClientOrderEnquiryModule'
      },
      {
        path: '',
        loadChildren: './periodic-test/periodic-test.module#PeriodicTestModule'
      }, {
        path: '',
        loadChildren: './loss-calculation/loss-calculation.module#LossCalculationModule'
      },
       {
        path: '',
        loadChildren: './activity-log/activity-log.module#ActivityLogModule'
      },
      // {
      //   path: 'user-activity-log',
      //   component: UserActivityViewComponent
      // },
      {
        path: 'help',
        component: HelpComponent
      }
    ]
  }, {
    path: '',
    component: AuthLayoutComponent,
    children: [{
      path: 'pages',
      loadChildren: './pages/pages.module#PagesModule'
    }
    ]
  }
];
